import { getLanguage, getMarket } from '../modules/i18n';
import { getMarketLabel } from '../modules/marketsData';
import type { JbInTextTeaser } from '@bjb/bjb-web-components/dist/components/jb-in-text-teaser/jb-in-text-teaser';

function shouldBeRemoved(jbInTextTeaser: JbInTextTeaser&HTMLElement, currentMarket: number): boolean {
  const onlyMarkets = jbInTextTeaser.getAttribute('data-only-markets');
  const onlyMarketsArray = onlyMarkets?.split(',').map((market) => parseInt(market.trim(), 10));
  const isInOnlyMarkets = onlyMarketsArray?.some((market) => market === currentMarket);
  return !isInOnlyMarkets;
}

async function setMarket(inTextTeaser: JbInTextTeaser&HTMLElement, currentMarket: number, currentLanguage: number) {
  const marketLabel = await getMarketLabel(currentMarket, currentLanguage);
  inTextTeaser.market = {
    marketName: marketLabel,
  };
}

window.addEventListener('DOMContentLoaded', async () => {
  const currentMarket = parseInt(await getMarket(), 10);
  const currentLanguage = parseInt(await getLanguage(), 10);

  document.querySelectorAll<JbInTextTeaser&HTMLElement>('jb-in-text-teaser[data-only-markets]').forEach(async (inTextTeaser) => {
    if (shouldBeRemoved(inTextTeaser, currentMarket)) {
      const parent = inTextTeaser.parentElement;
      if (parent && parent.tagName === 'JB-CONTENT-SPACING') {
        parent.remove();
      }
      inTextTeaser.remove();
      return;
    }

    setMarket(inTextTeaser, currentMarket, currentLanguage).then();
  });
});
